import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IGameData, ILaid, RecordState } from '../../../redux/types';
import { getHintPosition, Hints } from '../../../functions/hints';
import { Dispatch } from 'redux';
import { increaseHintNumber, toggleModal, undo, changeScores, changeVolume } from '../../../redux/actions';
import { Orientation } from '../../../utils/detectOrientation';
import DesktopNavBar from './Desktop';
import BottomNavigation from './Bottom';
import global from '../../../global';

type Props = {
  getStage: () => any;
  hints: Hints;
  laid: ILaid;
  gameData: IGameData;
  hintNumber: number;
  size: number;
  increaseHintNumber: () => void;
  undo: () => void;
  changeScores: (scores: number) => void;
  orientation: Orientation | void;
  toggleModal: (name: string) => void;
  gameId: number;
  onVolumeChange: () => void;
  volume: boolean;
};

class NavBar extends Component<Props> {
  onHintHoldClick: boolean = false;

  state = {
    isMobileMenuVisible: false,
  };

  toggleMobileMenu = () => {
    const { isMobileMenuVisible } = this.state;
    this.setState({ isMobileMenuVisible: !isMobileMenuVisible });
  };

  onNewGame = () => {
    this.props.toggleModal('newGame');
  };

  onRestart = () => {
    this.props.toggleModal('restart');
  };

  onVolumeChange = () => {
    this.props.onVolumeChange();
  };

  onHint = () => {
    if (this.onHintHoldClick) return;
    this.onHintHoldClick = true;

    const { hintNumber, increaseHintNumber, size, hints, changeScores } = this.props;
    if (!hints.length) return;

    const hint = hints[hintNumber];

    const card = global.getStage().findOne(`.${hint.cardSelector}`);
    if (!card) return;

    const { moveTo } = card.attrs;
    const hintPos = getHintPosition(hint, size);

    const cardRect = card.getClientRect({ skipShadow: true, skipStroke: true });
    const x = hintPos.x;
    const y = hintPos.y - cardRect.y + card.y();
    changeScores(-10);
    moveTo(card, x, y, cardRect.x).then(() => {
      increaseHintNumber();
      this.onHintHoldClick = false;
    });
  };

  onFullScreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
      return;
    }
    document.documentElement.requestFullscreen();
  };

  render() {
    const { gameData, orientation, undo, gameId, volume } = this.props;

    return (
      <>
        {orientation === Orientation.Desktop && (
          <DesktopNavBar
            volume={volume}
            onVolumeChange={this.onVolumeChange}
            onUndo={undo}
            onHint={this.onHint}
            gameData={gameData}
            onFullScreen={this.onFullScreen}
            toggleMenu={this.toggleMobileMenu}
            gameId={gameId}
            onShowPaymentSubscription={() => {}}
          />
        )}
        {orientation === Orientation.Portrait && (
          <BottomNavigation
            toggleMenu={this.toggleMobileMenu}
            onUndo={undo}
            onFullScreen={this.onFullScreen}
            onHint={this.onHint}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state: RecordState) {
  return {
    hints: state.get('hints'),
    laid: state.getIn(['gameState', 'laid']),
    gameData: state.get('gameData'),
    hintNumber: state.get('hintNumber'),
    size: state.get('size'),
    orientation: state.get('orientation'),
    gameId: state.get('id'),
    volume: state.get('volume'),
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    increaseHintNumber: bindActionCreators(increaseHintNumber, dispatch),
    undo: bindActionCreators(undo, dispatch),
    toggleModal: bindActionCreators(toggleModal, dispatch),
    changeScores: bindActionCreators(changeScores, dispatch),
    onVolumeChange: bindActionCreators(changeVolume, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
